import { useState, useEffect } from "react";

import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import {
  AppBar,
  Container,
  Paper,
  Toolbar,
  Typography,
} from "@material-ui/core";
import GetAppIcon from "@material-ui/icons/GetApp";

import { firefunctions } from "../../../components/firebase/FirebaseProvider";

import MaterialTable from "material-table";
import ExcelFile from "@ibrahimrahmani/react-export-excel/dist/ExcelPlugin/components/ExcelFile";
import ExcelSheet from "@ibrahimrahmani/react-export-excel/dist/ExcelPlugin/elements/ExcelSheet";
import ExcelColumn from "@ibrahimrahmani/react-export-excel/dist/ExcelPlugin/elements/ExcelColumn";

import DateFnsUtils from "@date-io/date-fns";
import { set } from "date-fns";

import Footer from "../../../components/molecules/LoginNav/footer";
import TableIcons from "../../../components/tableicon/table-icons";

import currency from "../../../utils/currency";

import TokorameIcon from "../../../assets/logo-tokorame.svg";
import useStyles from "./style";

function PreorderReport() {
  const classes = useStyles();

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const [startDate, setStartDate] = useState(
    set(new Date(), {
      hours: 0,
      minutes: 0,
      seconds: 0,
      milliseconds: 0,
    })
  );

  const [endDate, setEndDate] = useState(
    set(new Date(), {
      hours: 23,
      minutes: 59,
      seconds: 59,
      milliseconds: 999,
    })
  );

  const orderStatus = {
    pending: "Menunggu pembayaran",
    paid: "Sudah dibayar",
    "ready-for-process": "Menunggu diproses",
    "on-process": "Sedang diproses",
    queued: "Diantrekan",
    "waiting-for-settlement": "Menunggu pelunasan",
    "on-delivery": "Sedang dikirim",
    received: "Diterima",
  };

  const [table, setTable] = useState({
    columns: [
      {
        title: "Tanggal",
        field: "paid_at",
      },
      {
        title: "Kode Order",
        field: "kode_order",
      },
      {
        title: "Nama Seller",
        field: "nama",
      },
      {
        title: "Subdomain",
        field: "subdomain",
      },
      {
        title: "Status Order",
        field: "status_pengiriman",
        render: (row) =>
          orderStatus[row.status_pengiriman] || row.status_pengiriman || "-",
      },
      {
        title: "Total Tagihan",
        field: "total_tagihan",
        render: (row) => currency(row.total_tagihan)
      },
      {
        title: "Promo",
        field: "total_promo",
        render: (row) => currency(row.total_promo)
      },
      {
        title: "Komisi",
        field: "komisi",
        render: (row) =>
          row.komisi_tertahan > 0 ? (
            <span style={{ color: "orange" }}>{currency(row.komisi_tertahan)}</span>
          ) : (
            <span style={{ color: "green" }}>{currency(row.komisi)}</span>
          ),
      },
    ],
    data: [],
  });

  const getData = async () => {
    setLoading(true);
    try {
      const func = firefunctions.httpsCallable("statistic-preorderList");
      const data = {
        start_date: startDate.toISOString().substring(0, 10),
        end_date: endDate.toISOString().substring(0, 10),
      };

      const res = await func(data);
      setData(res?.data ?? []);
      setTable((table) => {
        const obj = {
          ...table,
          data:
            res?.data?.map((doc) => {
              return {
                ...doc,
              };
            }) || [],
        };
        return obj;
      });
      setLoading(false);
    } catch (error) {
      setData([]);
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, [startDate, endDate]);

  const ExcelFileWrapper = () => {
    return (
      <ExcelFile
        filename="List Preorder"
        element={
          data?.length > 0 ? (
            <div
              style={{
                // marginTop: "20px",
                marginBottom: "12px",
                // marginLeft: 24,
                border: "1px solid #5675D3",
                // marginRight: 24,
                borderRadius: 4,
                backgroundColor: "#DEE4F7",
                padding: "12px",
                justifyContent: "center",
                display: "flex",
                cursor: "pointer",
              }}
            >
              <div style={{ marginRight: 8, alignSelf: "center" }}>
                <GetAppIcon color="primary" />
              </div>
              <div style={{ marginTop: "2.5px" }}>
                <Typography
                  color="primary"
                  style={{
                    fontSize: 13,
                    color: "#5675D3",
                  }}
                >
                  Silahkan Klik Disini Untuk Mendownload Data Lebih
                  Lengkap.
                </Typography>
              </div>
            </div>
          ) : null
        }
      >
        <ExcelSheet data={data} name="List Preorder">
          <ExcelColumn
            label="Tanggal"
            value="paid_at"
          />
          <ExcelColumn
            label="Kode Order"
            value="kode_order"
          />
          <ExcelColumn
            label="Nama Seller"
            value="nama"
          />
          <ExcelColumn
            label="Subdomain"
            value="subdomain"
          />
          <ExcelColumn
            label="Level"
            value="level"
          />
          <ExcelColumn
            label="Status"
            value="status"
          />
          <ExcelColumn
            label="Status Pembayaran"
            value="status_pembayaran"
          />
          <ExcelColumn
            label="Status Pengiriman"
            value="status_pengiriman"
          />
          <ExcelColumn
            label="Total Tagihan"
            value="total_tagihan"
          />
          <ExcelColumn
            label="Total Tagihan Harga Normal"
            value="total_tagihan_harga_normal"
          />
          <ExcelColumn
            label="Total Promo"
            value="total_promo"
          />
          <ExcelColumn
            label="Komisi"
            value={(col) =>
              col.komisi_tertahan > 0 ? col.komisi_tertahan : col.komisi
            }
          />
        </ExcelSheet>
      </ExcelFile>
    )
  }

  return (
    <Paper className={classes.paperWrap}>
      <AppBar position="static" style={{ backgroundColor: "#AABBE9" }}>
        <Toolbar>
          <div className={classes.wrapHeader}>
            <div className={classes.wrapIcon}>
              <img src={TokorameIcon} alt="tokorame" />
            </div>
          </div>
        </Toolbar>
      </AppBar>
      <div className={classes.pageWrapWrap}>
        <div className={classes.content}>
          <div className={classes.root}>
            <Container>
              <ExcelFileWrapper />
              <div style={{ marginBottom: "12px" }}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    style={{
                      marginRight: "10px",
                    }}
                    disableToolbar
                    variant="inline"
                    inputVariant="outlined"
                    format="yyyy-MM-dd"
                    margin="normal"
                    id="date-picker-inline"
                    label="Tanggal Awal"
                    value={startDate}
                    onChange={setStartDate}
                    maxDate={new Date()}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    disabled={loading}
                  />
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    inputVariant="outlined"
                    format="yyyy-MM-dd"
                    margin="normal"
                    id="date-picker-inline"
                    label="Tanggal Akhir"
                    value={endDate}
                    onChange={setEndDate}
                    minDate={startDate}
                    maxDate={new Date()}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    disabled={loading}
                  />
                </MuiPickersUtilsProvider>
              </div>
              <MaterialTable
                columns={table.columns}
                data={table.data}
                title="Data Laporan Preorder"
                isLoading={loading}
                icons={TableIcons}
                options={{
                  pageSize: 5,
                  pageSizeOptions: [5, 10, 25, 50, 100],
                  headerStyle: {
                    fontWeight: "bold",
                  },
                }}
                localization={{
                  body: {
                    emptyDataSourceMessage: loading ? null : "Tidak Ada Data",
                  },
                  toolbar: {
                    searchTooltip: "Cari",
                    searchPlaceholder: "Cari Data",
                  },
                  header: {
                    actions: "Actions",
                  },
                  pagination: {
                    labelRowsSelect: "Baris",
                    labelDisplayedRows: " {from}-{to} Dari {count} Baris",
                    firstTooltip: "Halaman Pertama",
                    previousTooltip: "Halaman Sebelumnya",
                    nextTooltip: "Halaman Selanjutnya",
                    lastTooltip: "Halaman Terakhir",
                  },
                }}
              />
            </Container>
          </div>
        </div>
      </div>
      <Footer />
    </Paper>
  );
}

export default PreorderReport;
